import * as Forms       from '../components/forms';
import * as User        from '../user';
import { compose }      from 'redux';
import { connect }      from 'react-redux';
import React            from 'react';
import StandaloneButton from '../components/standalone_button';


function ProfilePage({ businessID, profile,  save, signOut }) {
  return (
    <Forms.EditPage
      record={profile}
      title={profile.name}
      save={save}>
      {editPage => (
        <div className="page-content">
          <Forms.Form {...editPage}>
            <ProfileFields/>
          </Forms.Form>
          {profile.email && !editPage.isEditing && (
            <StandaloneButton
              label="Change Password"
              href={`/${businessID}/account/profile/change_password`}
              className="change-password-button"
            />
          )}
          {!profile.email && !editPage.isEditing && (
            <StandaloneButton
              label="Set Password"
              href={`/${businessID}/account/profile/change_password`}
              className="change-password-button"
            />
          )}
          {!editPage.isEditing && (
            <StandaloneButton label="Sign Out" onClick={signOut} danger={true}/>
          )}
        </div>
      )}
    </Forms.EditPage>
  );
}


function ProfileFields({ ...form }) {
  return (
    <div className="list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input {...form} label="Name" name="name" type="text" required={true}/>
        <Forms.Input {...form} label="Phone number" name="phone" type="tel"/>
        <Forms.Input {...form} label="Email" name="email" type="email"/>
        <Forms.Input {...form} label="Job title" name="title" type="text"/>
      </ul>
    </div>
  );
}


export default connect(
  state => ({
    profile: User.getProfile(state)
  }),
  dispatch => ({
    save:    compose(dispatch, User.updateProfile),
    signOut: compose(dispatch, User.signOut)
  })
)(ProfilePage);
